// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"styles_m-1480__9nb8q","layout":"styles_layout__ewyWz","en":"styles_en__kc7Rp","main":"styles_main__NgTls"};